<template>
  <div class="backview">
    <div class="page-step">
      <!-- 步骤条 -->
      <div class="step-wrapper">
        <div class="step-item" v-for="(step, index) in steps" :key="index">
          <div class="step-circle" :class="getStepClass(index)">{{ index + 1 }}</div>
          <div class="step-text" :class="getStepClass(index)">
            <div class="cn">{{ step.cn }}</div>
            <div class="en">{{ step.en }}</div>
          </div>
          <div class="step-line" v-if="index < steps.length - 1" :class="{ 'line-done': index < currentStep }"></div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="course-class-topback">
        <img
          class="course-left-backimg"
          src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png"
        />
        <div class="course-title">
          <div class="cn">报名领域</div>
          <div class="en">Select the field for registration</div>
        </div>
      </div>
      <div class="tabs">
        <div class="tab" @click="selFn(i)" :class="i > 1 ? 'disabled' : currentIndex === i ? 'current' : ''" v-for="(value, i) in list" :key="i" :style="{'background-image': 'url('+ value.picUrl +')'}">
          <div class="cn">{{ value.theme }}</div>
          <div class="en">{{ value.enTheme }}</div>
        </div>
      </div>
      <div class="course-class-topback">
        <img
          class="course-left-backimg"
          src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png"
        />
        <div class="course-title">
          <div class="cn">报名方向</div>
          <div class="en">Select the registration direction</div>
        </div>
      </div>
      <div class="card-box">
        <div class="card" v-for="(item, j) in child.ctheme" :key="j" @click="chooseFn(item)" :style="{'background-image': 'url('+ item.picUrl +')'}">
          <div class="btn">前往报名</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      steps: [
        { cn: '选择方向', en: 'Select Field' },
        { cn: '组建队伍', en: 'Build Team' },
        { cn: '信息审核', en: 'Info Review' },
        { cn: '报名支付', en: 'Register & Pay' }
      ],
      currentStep: 0,
      list: [],
      currentIndex: 0,
      dict_schoolGroup: this.$curUtils.dict_schoolGroup(),
      statusArr: [
        // 0-已提交，1-审核通过/待缴费，2-审核未通过，3-已缴费 4-已退费
        { code: 0, label: '待缴费', type: 'warning' },
        { code: 1, label: '待缴费', type: 'warning' },
        { code: 2, label: '审核未通过', type: 'danger' },
        { code: 3, label: '已缴费', type: 'success' },
        { code: 4, label: '已退费', type: 'info' }
      ],
      child: {}
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getStepClass (index) {
      if (index < this.currentStep) return 'step-done'
      if (index === this.currentStep) return 'step-active'
      return 'step-pending'
    },
    downloadFn () {
      window.open('https://cdn.spbcn.org/ghac/file/学生展演指导手册.pdf')
      // this.fileLinkToStreamDownload('https://cdn.spbcn.org/ghac/file/学生展演指导手册.pdf', '学生展演指导手册')
    },
    backClicked () {
      this.$router.back()
    },
    getList () {
      this.$http.get('club/getTreeList').then(res => {
        if (res.code === 200) {
          this.list = res.data
          this.child = res.data[this.currentIndex]
        }
      })
    },
    selFn (index) {
      if (index > 1) return
      this.currentIndex = index
      this.child = this.list[index]
    },
    chooseFn (item) {
      this.$router.push({
        path: '/club/register',
        query: {
          id: item.id,
          theme: item.theme,
          entheme: item.enTheme,
          customize: item.customize ? 1 : 0,
          step: 1,
          val: this.child.theme,
          enval: this.child.enTheme
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.download{
  text-decoration: underline;
  margin-top: 20px;
}
.backview {
  height: 100%;
  width: 100%;
  position: relative;
}

.sec-title {
  width: 260px;
  height: 38px;
  background-image: url(https://cdn.spbcn.org/ghac/ghac_button_highlight.png);
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  font-family: hzgb;
  font-size: 18px;
  line-height: 38px;
  margin: 40px auto 30px;
  letter-spacing: 2px;
  cursor: pointer;
}
.upload{
  background-image: url(https://cdn.spbcn.org/ghac/flag-border.png);
  background-size: 560px 60px;
  background-position: center;
  background-repeat: no-repeat;
  width: 600px;
  height: 80px;
  line-height: 80px;
  margin: 20px auto;
  background-color: #b81b26;
  border-radius: 14px;
  color: #fff;
  font-size: 32px;
  font-family: regular;
  text-align: center;
  cursor: pointer;
}
.tabs{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  .tab{
    width: 24%;
    height: 100px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 16px;
    color: #fff;
    font-family: systh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .cn{
      font-size: 20px;
    }
    .en{
      font-size: 12px;
    }
    &.disabled{
      filter: grayscale(100%);
      cursor: not-allowed;
    }
    &.current{
      background-color: #b81b26;
      background-image: none !important;
    }
  }
}
.card-box{
  .card{
    width: 180px;
    height: 250px;
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    background-repeat: no-repeat;
    background-position: top left;
    background-size: 100% auto;
    border-radius: 16px;
    position: relative;
    .btn{
      position: absolute;
      width: 120px;
      height: 40px;
      color: #000;
      background-color: #fff;
      text-align: center;
      line-height: 40px;
      font-family: alih;
      font-size: 14px;
      border-radius: 6px;
      left: calc(50% - 60px);
      bottom: 30px;
      display: none;
      cursor: pointer;
    }
    &:hover .btn{
      display: block;
    }
  }
}
</style>
